import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { ConstructDestinationUrl, URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";

const PLATFORM = Platform.TWITTER;

export const TwitterDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: [
    {
      title: "What does the Twitter integration do?",
      content: `Northbeam natively integrates with the Twitter API. By doing so, we pull all your current and historical Campaigns, Adsets, and Ads from your account, along with a list of useful metrics.
        Notably, we pull impressions, which fuel our view model and unlock our Clicks + Modeled Views attribution model.`,
    },

    {
      title: "What does the Twitter UTM track?",
      content: (
        <div>
          Performance metrics are tracked with UTMs. Northbeam then maps
          performance from UTMs to spend pulled our Native Integration.
        </div>
      ),
    },
    {
      title: "How is spend tracked for Twitter?",
      content: (
        <>Spend is tracked through Northbeam’s Native Integration below.</>
      ),
    },
  ],
};

export const TwitterSetup = ({
  connectionContent,
}: {
  connectionContent: React.ReactNode;
}) => (
  <>
    <SetupSection title="Log into Twitter to connect integration">
      {connectionContent}
    </SetupSection>
    <SetupSection title="Generate Twitter URL's with Northbeam UTMs">
      <ul className=" list-decimal  pl-4 mb-0">
        <li>
          Make a copy of this{" "}
          <a
            href="https://docs.google.com/spreadsheets/d/1ffIP4w0wMRI2Kh0DykrTRryTXsubz4v2Tan5H83ZOeM/edit?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            URL Builder Google Sheet
          </a>
          .
        </li>
        <li>
          Enter in your campaign, ad group and ad names to be able to create the
          URL with UTMs attached.
        </li>
      </ul>
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
